import firebase from "firebase/app";
import "firebase/firestore";

export class TicketUser {
  public id = "";
  public price = 0;
  public purchasedAt = firebase.firestore.Timestamp.fromDate(new Date());
  public lastName = "";
  public firstName = "";
  public userId = "";
  public ticketId = "";
  public ticketName = "";
  public salonName = "";
  public salonId = "";
  public salonIdSystem = "";
  public salonGenre = 1;
  public prefecture = "";
  public city = "";
  public tickeCreatedAt = firebase.firestore.Timestamp.fromDate(new Date());
  public usedCount = 0;
  public availableCount = 0;
  public expiredAt = firebase.firestore.Timestamp.fromDate(new Date());
  public authDate = firebase.firestore.Timestamp.fromDate(new Date());
  public paymentDate = firebase.firestore.Timestamp.fromDate(new Date());
  public status = 1;
  public chargeId = "";
  public transferGroupId = "";
  public subscriptionId = "";
  public description = "";
  public thanksContent = "";
  public type = 1;
  public imageURL = "";
  public expirationDate = 0;
  public number = 0;
  public expiredAt30Flag = false;
  public expiredAt7Flag = false;
  public expiredAt1Flag = false;
  public expiredAtNowFlag = false;
  public firstFlag = true;
  public createdAt = firebase.firestore.Timestamp.fromDate(new Date());
  public updatedAt = firebase.firestore.Timestamp.fromDate(new Date());
}
